export enum TickerItemCategory {
    Question = 'question',
    Post = 'post',
    Activity = 'activity',
    Transition = 'transition',
}
